import { render } from "./recordHeader.vue?vue&type=template&id=953db592&scoped=true"
import script from "./recordHeader.vue?vue&type=script&lang=js"
export * from "./recordHeader.vue?vue&type=script&lang=js"

import "./recordHeader.vue?vue&type=style&index=0&id=953db592&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-953db592"]])

export default __exports__